  $('.publish-request-company').on('click', function () {
    if (!confirm('高専Link運営事務局に公開申請をします。よろしいですか？')) {
      return false;
    }
  return true;
  });
